import React, { Fragment } from 'react';
import styled from 'styled-components';
import { isString, isNumber } from 'lodash';
import { globalTheme } from '@clds/component-theme';

export const isStringOrNumber = (value) => isString(value) || isNumber(value);

export const MoreCrumbButton = styled.div.attrs(({ onClick }) => (onClick ? { role: 'button' } : undefined))`
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  & + & {
    margin-top: ${globalTheme.spacing.xs};
  }
`;

export const getHiddenCrumbComponent = (list, hiddenCrumbsLength) => {
  const children = list.slice(1, hiddenCrumbsLength + 1).map(
    ({ tooltipTitle, ...props }, index) =>
      tooltipTitle && (
        <MoreCrumbButton key={`more-crumb-${index}`} {...props}>
          {tooltipTitle}
        </MoreCrumbButton>
      )
  );

  const tooltipTitle = <Fragment children={children} />;

  return { children: '...', tooltipTitle, className: 'more-crumb', forceTooltip: true, disabled: true };
};
